import {
  LucideIcon,
  LayoutDashboard,
  MessageSquare,
  MessageCircle,
  Heart,
  FileText,
  Users,
  BarChart3,
} from 'lucide-react';
import type { User } from '../types';

export interface MenuItem {
  path: string;
  label: string;
  icon: LucideIcon;
  allowedRoles: ('superuser' | 'staff' | 'moderator')[];
  requireAll?: boolean;
}

export interface MenuSection {
  heading?: string;
  items: MenuItem[];
}

export const getMenuItems = (user: User | null): MenuSection[] => {
  const allMenuItems: MenuItem[] = [
    {
      path: '/dashboard',
      label: 'Dashboard',
      icon: LayoutDashboard,
      allowedRoles: ['superuser'],
    },
    {
      path: '/statistics',
      label: 'İstatistikler',
      icon: BarChart3,
      allowedRoles: ['superuser'],
    },
    {
      path: '/contents',
      label: 'İçerikler',
      icon: FileText,
      allowedRoles: ['superuser', 'moderator'],
    },
    {
      path: '/comments',
      label: 'Yorumlar',
      icon: MessageCircle,
      allowedRoles: ['superuser', 'moderator'],
    },
    {
      path: '/likes',
      label: 'Beğeniler',
      icon: Heart,
      allowedRoles: ['superuser', 'moderator'],
    },
    {
      path: '/users',
      label: 'Kullanıcılar',
      icon: Users,
      allowedRoles: ['superuser', 'moderator'],
    },
    {
      path: '/moderation',
      label: 'Moderasyon',
      icon: MessageSquare,
      allowedRoles: ['moderator', 'staff'],
    },
  ];

  if (!user) return [];

  // Filter menu items based on user roles
  const filteredItems = allMenuItems.filter((item) => {
    const hasAccess = item.requireAll
      ? item.allowedRoles.every((role) => {
          if (role === 'superuser') return user.isSuperuser;
          if (role === 'staff') return user.isStaff;
          if (role === 'moderator') return user.isModerator;
          return false;
        })
      : item.allowedRoles.some((role) => {
          if (role === 'superuser') return user.isSuperuser;
          if (role === 'staff') return user.isStaff;
          if (role === 'moderator') return user.isModerator;
          return false;
        });
    return hasAccess;
  });

  // Group items into sections
  const sections: MenuSection[] = [];

  // General section (Dashboard, Statistics)
  const generalItems = filteredItems.filter(
    (item) => item.path === '/dashboard' || item.path === '/statistics',
  );
  if (generalItems.length > 0) {
    sections.push({ items: generalItems });
  }

  // Content Management section
  const contentItems = filteredItems.filter(
    (item) =>
      item.path === '/moderation' ||
      item.path === '/contents' ||
      item.path === '/comments' ||
      item.path === '/likes' ||
      item.path === '/users',
  );
  if (contentItems.length > 0) {
    sections.push({ heading: 'İçerik Yönetimi', items: contentItems });
  }

  return sections;
};
